import { TQuestion, TQuestionBankCategory, TQuestionBankCategoryTree } from '@/types/QuestionBank';
import { requestDelete, requestGet, requestPost, requestPut } from '@/utils/request';
import { TApi } from '@/types/interface';

/**
 * 新建分类
 * @param form
 */
export const createQuestionBankCategory = (
  form: TQuestionBankCategory,
): Promise<TApi<TQuestionBankCategory>> => {
  return requestPost(`/v2/camp/api/question/bank/category`, form);
};

export const updateQuestionBankCategory = (
  id: string,
  form: TQuestionBankCategory,
): Promise<TApi<TQuestionBankCategory>> => {
  return requestPut(`/v2/camp/api/question/bank/category/${id}`, form);
};

export const deleteQuestionBankCategory = (id: string) => {
  return requestDelete(`/v2/camp/api/question/bank/category/${id}`, {});
};

export const getQuestionBankCategoryTree = (): Promise<TApi<TQuestionBankCategoryTree>> => {
  return requestGet(`/v2/camp/api/question/bank/category/tree`);
};

export const listCampRelation = (id: string) => {
  return requestGet(`/v2/camp/api/question/bank/category/${id}/camp/relation`, {});
};

export const pageQuestion = (params: {
  current: number;
  size: number;
  key?: string;
  types?: number[];
  categoryId: string;
}) => {
  return requestPost(`/v2/camp/api/question/page`, params);
};

export const createQuestion = (form: TQuestion) => {
  return requestPost(`/v2/camp/api/question`, form);
};

export const updateQuestion = (id: string, form: TQuestion) => {
  return requestPut(`/v2/camp/api/question/${id}`, form);
};

export const enableQuestion = (id: string, enable: number) => {
  return requestPut(`/v2/camp/api/question/${id}/enable?enable=${enable}`, {});
};

export const deleteQuestion = (id: string) => {
  return requestDelete(`/v2/camp/api/question/${id}`, {});
};
